import { ProductOffering } from '../../interfaces';
import { getCountryName } from '../../utils';

type AppType = 'mobile_app' | 'mobile_web' | 'web';
type EnvironmentType = 'live' | 'dev';
export interface DefaultEvent {
  app_type: AppType;
  environment: EnvironmentType;
  language_code: string;
  currency_code?: string | null;
}

interface Props {
  isNative?: boolean;
  isProd?: boolean;
  isMobileWeb?: boolean;
  currentLanguage: string;
  currencyCode?: string | null;
}
export const getDefaultEventData = ({
  isNative,
  isProd,
  isMobileWeb,
  currentLanguage,
  currencyCode,
}: Props): DefaultEvent => {
  let app_type: AppType;
  const environment: EnvironmentType = isProd ? 'live' : 'dev';

  if (isNative) {
    app_type = 'mobile_app';
  } else if (isMobileWeb) {
    app_type = 'mobile_web';
  } else {
    app_type = 'web';
  }

  return {
    app_type,
    environment,
    language_code: currentLanguage,
    currency_code: currencyCode,
  };
};

export const getSelectedCountry = (
  planDetails: ProductOffering,
  locationStateCountryName?: string | null,
): string => {
  if (planDetails.countries.length === 1) {
    return getCountryName(planDetails.countries[0].description);
  }

  return locationStateCountryName ?? 'Countries';
};

export const getFeaturedItemAndTextForTracking = (
  product: ProductOffering,
): {
  isFeaturedItem: boolean;
  featuredText: string | null;
} => {
  const isFeaturedItem = product.featured;
  const featuredText =
    product.featured &&
    (product.featured_text === null || product.featured_text === undefined)
      ? 'Top Seller'
      : product.featured_text;

  return { isFeaturedItem, featuredText };
};
